import format from 'date-fns/format';
export function formatDateISO(value) {
    const date = ensureDate(value);
    return date.toISOString();
}
export function formatDate(value, formatString = 'MMMM do yyyy', removeTimeZone = false) {
    const date = ensureDate(value, removeTimeZone);
    return format(date, formatString);
}
export function ensureDate(value, removeTimeZone = false) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
        if (removeTimeZone && date.toISOString().includes("T")) {
            date = new Date(date.toISOString().slice(0, -5));
        }
    }
    return date;
}
export function equalDates(startDate, endDate) {
    const sd = ensureDate(startDate);
    const ed = ensureDate(endDate);
    return sd.toDateString() === ed.toDateString();
}
